import { useCallback } from "react";
import { NavigateOptions, useNavigate } from "react-router-dom";

import { RouteParams, RoutePath } from "../routes";
import { buildUrl } from "../utils/buildUrl";

export function useNavigation() {
    const navigate = useNavigate();

    const navigateTo = useCallback(
        <T extends RoutePath>(
            path: T,
            params?: T extends keyof RouteParams ? RouteParams[T] : never,
            options?: NavigateOptions
        ) => {
            if (params) {
                navigate(buildUrl(path, params), options);
            } else {
                navigate(path, options);
            }
        },
        [navigate]
    );

    const goBack = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    return {
        navigateTo,
        goBack,
    };
}
